import { useQuery } from '@tanstack/react-query'
import { authSSO } from '../services/loginSevices'
import { useEffect } from 'react'
import { useSessionStore } from '../store/sessionStore'

export function useAuth() {
  const {
    myStore,
    userName,
    doLogin,
    doRefreshToken,
    changeLang,
    doLoginFinalize,
    doToken,
    doLocationToken,
  } = useSessionStore()
  const values = window.location.search

  // Get the URL code if it exists
  const code = new URLSearchParams(values).get('code')
  const query = useQuery({
    queryKey: ['authSSO', { code }],
    queryFn: () =>
      authSSO({
        code: code,
        redirectUri: process.env.REACT_APP_MICROSOFT_REDIRECT_URI,
        originApp: process.env.REACT_APP_ORIGIN_APP,
      }),
    enabled: !!code,
    retry: false,
  })

  // We use a useEffect to handle side-effects when data changes
  useEffect(() => {
    if (query?.data) {
      const data = query.data
      doLogin({
        user: data.mailNickName,
        userName: data.displayName,
        rol: { id: data.rolId, name: data.rolName },
        email: data.mail,
        myStore: {
          id: data.officeId,
          name: data.officeName,
          officeLocation: data.officeLocation,
        },
        countryCode: data.countryCode,
      })
      doLocationToken(data?.location)
      doToken(data.accessToken)
      doRefreshToken(data.refreshToken)
      changeLang(data.preferredLanguage)
    }
  }, [
    changeLang,
    doLogin,
    doRefreshToken,
    doToken,
    doLocationToken,
    query.data,
  ])

  useEffect(() => {
    if (query?.isError && code) {
      // Remove the 'code' parameter from the URL
      const url = new URL(window.location.href)
      url.searchParams.delete('code')
      window.history.replaceState(null, '', url.toString())
    }
  }, [query?.isError, code])

  useEffect(() => {
    if (myStore && userName) {
      doLoginFinalize(true) //It is auto redirected to dashboard by the router when setting login to true
    }
  }, [doLoginFinalize, myStore, userName])

  const goToSSO = () => {
    window.location.href =
      'https://login.microsoftonline.com/720b637a-655a-40cf-816a-f22f40755c2c/oauth2/v2.0/authorize?client_id=' +
      process.env.REACT_APP_MICROSOFT_CLIENT_ID +
      '&redirect_uri=' +
      process.env.REACT_APP_MICROSOFT_REDIRECT_URI +
      '&scope=' +
      process.env.REACT_APP_MICROSOFT_SCOPE +
      '&response_type=code&response_mode=query'
  }

  return {
    ...query,
    goToSSO,
  }
}
